import { render, staticRenderFns } from "./TicketCommentDistant.vue?vue&type=template&id=9934b536&scoped=true"
import script from "./TicketCommentDistant.vue?vue&type=script&lang=ts"
export * from "./TicketCommentDistant.vue?vue&type=script&lang=ts"
import style0 from "./TicketCommentDistant.vue?vue&type=style&index=0&id=9934b536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9934b536",
  null
  
)

export default component.exports